export default {
  id: 6,
  title: 'Target #6 - Missing Slice',
  url: 'https://cssbattle.dev/play/6',
  colors: ['#E3516E', '#F7F3D7', '#51B5A9', '#FADE8B'],
  solution:
    '<a a><a b><a c><style>body{background:#E3516E}a{position:fixed;width:100;height:100;bottom:50%;left:100;border-top-left-radius:100%}a[a]{background:#51B5A9}a[b]{background:#FADE8B;transform:rotate(90deg)}a[c]{background:#F7F3D7;transform:rotate(-90deg)}a[b],a[c]{transform-origin:bottom right}</style>',
}
